import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'homepage-v2',
		component: loadable(async () => import(/* webpackChunkName: "pages/homepage_v2" */ './index'), {
			exportName: 'Homepage',
			fallback: Loading,
		}),
		frame: {
			footer: true,
			header: true,
			width: 'large',
		},
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		path: '/v2',
		ssr: {
			enabled: true,
			seo: true,
		},
	},
];
